import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * A custom element that wraps the Sold Out / Sale / Preorder / Beginner
 * Friendly badges shown above the product title on the PDP
 * (blocks/_product-details.liquid). Listens for variant select events and
 * swaps in the freshly-rendered badges for whichever variant is now
 * selected, so switching to a sold-out variant (e.g. 18 mesh on a product
 * where 13 mesh is in stock) updates the badge without a page reload -
 * mirrors assets/product-price.js's own event handling.
 *
 * @extends {Component}
 */
class PdpBadges extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * Handles product select event and updates the badges.
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const newBadges = detail.html.querySelector(`pdp-badges[data-block-id="${this.dataset.blockId}"]`);
        if (!newBadges) return;

        this.innerHTML = newBadges.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[pdp-badges] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('pdp-badges')) {
  customElements.define('pdp-badges', PdpBadges);
}
